



















import { defineComponent } from '@nuxtjs/composition-api';
import BaseInput from '@shared/components/@atoms/BaseInput/BaseInput.vue';
import { focus } from '@shared/ui/utilities/directives';

export default defineComponent({
  name: 'BaseSearchBar',
  components: { BaseInput },
  directives: {
    focus,
  },
  inheritAttrs: false,
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: [Number, String],
      default: null,
    },
    icon: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    listeners(): any {
      return {
        // @ts-ignore migrated from ui-library
        ...this.$listeners,
        'keyup.esc': () => this.$emit('input', ''),
        blur: () => this.$emit('blur'),
        'click:icon': () => this.$emit('click:icon', this.value),
      };
    },
  },
});
